import getTracksRequest from "../../requests/getTracks";

export const types = {
  SET_TRACKS: 'SET_TRACKS',
  SEARCH_TRACKS_REQUEST: 'SEARCH_TRACKS_REQUEST',
  SEARCH_TRACKS_SUCCESS: 'SEARCH_TRACKS_SUCCESS',
  SEARCH_TRACKS_FAILURE: 'SEARCH_TRACKS_FAILURE',
}

export const setTracks = tracks => {
  return (dispatch) => {
    dispatch({
      type: types.SET_TRACKS,
      payload: tracks
    })
  }
}

export const searchTracks = text => {
  return (dispatch) => {
    dispatch({
      type: types.SEARCH_TRACKS_REQUEST
    })
    getTracksRequest(text)
      .then(response => {
        dispatch({
          type: types.SEARCH_TRACKS_SUCCESS,
          result: response.data
        })
      })
      .catch(error => {
        dispatch({
          type: types.SEARCH_TRACKS_FAILURE,
          error
        })
      })
  }
}